module.exports = __webpack_public_path__ + "stylesheets/publish_a583402315f5a2de6139c4a123862240.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/publish.less
// module id = jPQQ
// module chunks = 153